import { Backdrop, CircularProgress } from '@material-ui/core';
import React,{useEffect} from 'react'
import {
    BannerContainerFluid,Container,HeadingText,DescText,Button
} from './BannerComponent.style';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import SubscribeNewsletter from './../../../../../../modals/SubscribeEmail'



const useStyles = makeStyles((theme) => ({
    backdrop: {
      zIndex: theme.zIndex.drawer + 4,
      color: '#fff',
    },
  }));
export default function HomeBannerComponent() {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    
    useEffect(() => {
        document.onreadystatechange = function () {
            if (document.readyState === 'complete') {
                setTimeout(() => {
                    setOpen(false);
                },3000)
            }
            if (document.readyState === "interactive") {
                console.log("page loaded the interactive");
                setOpen(true);
            }
            if (document.readyState === "loading") {
                console.log("page is loading");
                setOpen(true);                
            }
        }
    },[])
  return (
    <div>
        <Backdrop className={classes.backdrop} open={open} >
            <CircularProgress color="inherit" />
        </Backdrop>
        <BannerContainerFluid>
            <div style={{

                height:"200px"
            }}></div>
           <Container>
                <div className='row mt-50'>
                    <div className='col s12 m12 l6'>
                        <br/><br/><br/>
                        <br/><br/><br/>

                        <HeadingText>
                        Unlock the potentials 
                        of alternative savings 
                        & investment 
                        </HeadingText>
                        <div className='row'>
                            <div className='col s12 m9'>
                            <DescText>
                                Earn passive income from one easy to use app.
                            </DescText>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col s12'>
                                <div style={{
                                    display:"flex",
                                    flexWrap:"wrap"
                                }}>
                                    
                                    <a href='https://play.google.com/store/apps/details?id=com.yallavest.android'
                                    >
                                        <Button >
                                            <img src="https://res.cloudinary.com/yalla-ng/image/upload/v1657110914/re-brand/icons/logo-google-playstore.svg"
                                            width="40px"
                                            alt=""/>
                                            <div style={{width:"20px"}}></div>
                                            <div style={{
                                                marginTop:"15px"
                                            }}>
                                                <span className="left" style={{
                                                }}>GET IT ON</span>
                                                <span className="left" style={{
                                                    fontSize:"14.9425px",
                                                }}><b>Play Store</b></span>
                                            </div>
                                        </Button>
                                    </a>
                                    <div style={{width:"20px"}}></div>
                                    {/* <SubscribeNewsletter/> */}
                                    <a href="https://apps.apple.com/us/app/yalla-ng-save-invest/id1617363028">

                                    <Button>
                                        <img src="https://res.cloudinary.com/yalla-ng/image/upload/v1657110911/re-brand/icons/Appstor%20icon.svg"
                                        width="30px"
                                        alt=""/>
                                        <div style={{width:"20px"}}></div>
                                        <div style={{
                                            marginTop:"15px"
                                        }}>
                                            <span className="left" style={{
                                            }}>GET IT ON</span>
                                            <span className="left" style={{
                                                fontSize:"14.9425px",
                                            }}><b>App Store</b></span>
                                        </div>
                                    </Button>
                                    </a>

                                </div>

                            </div>
                            
                        </div>
                    </div>
                    <div className='col s12 m12 l1'></div>
                    <div className='col s12 m12 l5' >
                        <div className='row'>
                            <div className='col s12 m12 l12 center'>
                                <img width="80%"
                                className='center' src="https://res.cloudinary.com/yalla-ng/image/upload/v1663595526/re-brand/Home_Mock_up_New_1_niiduy.svg" alt=""/>
                            </div>
                        </div>
                        
                    </div>
                </div>
           </Container>
        </BannerContainerFluid>
    </div>
  )
}
